// src/components/NavBadge.jsx — Pastille de notification des menus parents de
// la barre de navigation principale (ADR-269). Style DS sobre : même pastille
// corail que les pills enfants de MessagesPanel. Zéro / invalide = ne rend
// RIEN (pas de pastille vide). aria-hidden : le bouton parent porte déjà
// l'aria-label descriptif (badgeAriaLabel) — la pastille est décorative.

import { DS } from "../lib/ui"
import { formatBadgeCount } from "../lib/nav-badges"

// `urgent` (couche confirmation 2026-08-18) : le badge vire TERRACOTTA avec un
// point d'exclamation quand une échéance d'empreinte passe sous 48 h — réservé
// au sous-onglet « Demandes d'horaires » (décision Dimitri). `tone` permet au
// badge de sous-onglet de rester bleu-gris hors urgence (le corail reste
// réservé aux pastilles parents).
export default function NavBadge({ count, testId, urgent = false, tone = null }) {
  const text = formatBadgeCount(count)
  if (text == null) return null
  return (
    <span
      data-testid={testId}
      aria-hidden="true"
      style={{
        background: urgent ? '#c1512d' : (tone || DS.corail),
        color: "#fff",
        borderRadius: 10,
        padding: "1px 7px",
        fontSize: 9.5,
        fontWeight: 700,
        minWidth: 17,
        textAlign: "center",
        lineHeight: "14px",
        display: "inline-block",
        flexShrink: 0,
      }}
    >
      {urgent ? `${text} !` : text}
    </span>
  )
}
